import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class PrioritySelectComponent implements IController {
  priority: any;
  noUnderline: any;
  noFloat: any;
  onChange: Function;

  options: any;
  displayMap: any;
  selectedPriority: any;

  constructor(private commonsConstants) {
  }

  $onInit() {
    this.options = this.commonsConstants.priorities;
    this.displayMap = this.commonsConstants.priorityKeys;

    this.selectedPriority = this.displayMap[this.priority];
  }

  $onChanges(changes) {
    if (changes.priority && !changes.priority.isFirstChange()) {
      this.selectedPriority = this.displayMap[this.priority];
    }
  }

  onPriorityChange(priorityString) {
    const priorityRef = _.find(this.options, (o) => {
      return o.value === priorityString;
    });
    if (priorityRef) {
      this.onChange({priority: priorityRef.key})
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('prioritySelect', {
    bindings: {
      priority: '<',
      noUnderline: '@?',
      noFloat: '@?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/priority-select/priority-select.html',
    controller: PrioritySelectComponent
  });
